const config = require("../config.js");
const vA387 = [289362, 105683, 201211, 361086];
const vA388 = [3742667];
class C244 {
  constructor(p9349, p9350, p9351) {
    p9351 = p9351 || {};
    this.active = true;
    this.id = p9349;
    this.name = p9350;
    this.score = p9351.player_score || 0;
    this.kills = p9351.player_kills || 0;
    this.deaths = p9351.player_deaths || 0;
    this.wins = p9351.player_wins || 0;
    this.hack = ~~(p9351.player_hack || 0);
    this.games = p9351.player_games_played || 0;
    this.clan = p9351.player_clanid;
    this.funds = p9351.player_funds || 0;
    this.featured = ~~(p9351.player_featured || 0);
    this.clan = p9351.player_clan || null;
    this.timePlayed = p9351.player_timeplayed || 0;
    this.skins = p9351.skins || [];
    this.invVal = p9351.player_skinvalue || 0;
    this.lastReward = p9351.player_lastreward || 0;
    this.isDev = ~~(p9351.player_developer || 0);
    this.following = p9351.player_following || 0;
    this.followers = p9351.player_followed || 0;
    this.stats = p9351.player_stats ? JSON.parse(p9351.player_stats) : {};
    this.partnerName = p9351.partner_name || null;
    this.partnerApp = p9351.partner_approved || 0;
    this.regionInd = p9351.player_region;
    this.role = p9351.player_role || 0;
    this.premiumT = p9351.player_premium || 0;
    this.premiumT = this.premiumT < 0 ? 0 : this.premiumT;
    this.pType = p9351.player_type || 0;
    this.twoFA = p9351.player_2FA || "";
    this.alias = this.premiumT ? p9351.player_alias || p9350 : p9350;
    this.createDate = p9351.player_datenew || "";
    this.twitch = p9351.tw_twitchname || null;
    this.isCreationMod = ~~(p9351.player_mapmod || 0);
    this.clanDeaths = p9351.clan_deaths || 0;
    this.clanKills = p9351.clan_kills || 0;
    this.clanTime = p9351.clan_time || 0;
    this.clanRole = p9351.player_clanrole || -1;
    this.jobRating = p9351.jobrating || 0;
    this.jobRatingPos = p9351.jobratingpositive || 0;
    this.reqDel = (p9351.player_cancelrequest || 0) > 0;
    this.externalToken = p9351.external_login_token || null;
    this.twitchId = p9351.tw_userid || null;
    this.twitchAT = p9351.tw_accesstoken || null;
    this.twitchRT = p9351.tw_refreshtoken || null;
    this.trades = p9351.player_trades || 0;
    this.refCode = p9351.partnercode || null;
    this.email = p9351.player_email || null;
    this.isAdmin = ~~(p9351.player_admin || 0);
    this.junk = p9351.player_jnk || 0;
    this.badges = (p9351.player_badge ? (p9351.player_badge || "").split(",") : []).map(Number);
    this.activeChallenges = [];
    this.metamask = p9351.player_metamask || null;
    this.isSkinMaker = ~~(p9351.player_skinmaker || 0);
    this.updateLevel();
    this.updatePerms();
  }
  setData(p9352) {
    this.kills = p9352[1];
    this.wins = p9352[2];
    this.games = p9352[3];
    this.deaths = p9352[4];
    this.funds = p9352[5];
    this.score = p9352[6];
    this.clan = p9352[7];
    this.timePlayed = p9352[8];
    this.featured = ~~p9352[9];
    this.skins = p9352[10];
    this.lastReward = p9352[11];
    this.isDev = ~~p9352[12];
    this.following = p9352[13];
    this.followers = p9352[14];
    this.stats = p9352[15];
    this.hack = ~~p9352[16];
    this.partnerName = p9352[17];
    this.partnerApp = p9352[18];
    this.regionInd = p9352[19];
    this.role = p9352[20];
    this.premiumT = p9352[21];
    this.twoFA = p9352[22];
    this.alias = this.premiumT ? p9352[23] || this.name : this.name;
    this.createDate = p9352[24];
    this.twitch = p9352[25];
    this.isCreationMod = ~~p9352[26];
    this.clanDeaths = p9352[27];
    this.clanKills = p9352[28];
    this.jobRating = p9352[29];
    this.jobRatingPos = p9352[30];
    this.reqDel = p9352[31];
    this.clanRole = p9352[32];
    this.clanTime = p9352[33];
    this.externalToken = p9352[34];
    this.twitchId = p9352[35];
    this.twitchAT = p9352[36];
    this.twitchRT = p9352[37];
    this.trades = p9352[38];
    this.refCode = p9352[39];
    this.email = p9352[40];
    this.isAdmin = p9352[41];
    this.invVal = p9352[42];
    this.junk = p9352[43];
    this.activeChallenges = p9352[44];
    this.badges = p9352[45];
    this.metamask = p9352[46];
    if (this.BP) {
      this.BP.bpp = p9352[47];
    }
    this.isSkinMaker = p9352[48];
    this.updateLevel();
    this.updatePerms();
  }
  getLevelProg() {
    const v7813 = this.level > 1 ? Math.pow(this.level / config.rankVar, 2) : 0;
    const v7814 = Math.pow((this.level + 1) / config.rankVar, 2);
    return parseInt(this.score - v7813) / parseInt(v7814 - v7813) * 100;
  }
  updateLevel() {
    const v7815 = config.rankVar * Math.sqrt(this.score);
    this.level = Math.floor(v7815);
    this.level = Math.max(1, this.level);
    this.levelProg = this.getLevelProg();
  }
  updatePerms() {
    this.isDeputy = this.role == 3;
    this.isMod = this.role == 2;
    this.canFlag = this.isDev || this.isMod || this.isDeputy;
    this.canGlobalFlag = this.isDev || this.isMod;
    this.canTeleport = this.isDev;
    this.canSuicide = this.isDev;
    this.canVerify = this.isDev;
    this.canBadge = vA387.indexOf(this.id) > -1;
    this.canGlobalKick = this.isDev || this.isMod;
    this.canSilentKick = this.isDev || this.isAdmin;
    this.canGlobalBan = this.isDev || this.isMod;
    this.canViewReports = this.isDev || this.isMod;
    this.canFeatureCreations = this.isDev;
    this.canDeleteCreations = this.isDev || this.isCreationMod;
    this.canGlobalEdit = this.isDev || this.isAdmin;
    this.canUseKRTrigger = this.isDev || this.isAdmin;
    this.canRehost = this.isDev || this.isAdmin || vA388.indexOf(this.id) > -1;
    if (this.createDate && new Date().getTime() - new Date(this.createDate).getTime() >= config.krTriggerReq) {
      this.canUseKRTrigger = true;
    }
  }
  setSkins(p9353) {
    let vO222 = {};
    if (p9353) {
      for (var vLN01264 = 0; vLN01264 < p9353.length; ++vLN01264) {
        vO222 = {
          ind: p9353[vLN01264].i,
          cnt: p9353[vLN01264].c,
          a: p9353[vLN01264].a || ""
        };
        if (p9353[vLN01264].a) {
          vO222.a = p9353[vLN01264].a;
        }
        this.skins.push(vO222);
      }
    }
  }
  addSkin(p9354, p9355) {
    p9354 = parseInt(p9354);
    if (!this.skins.some(p9356 => p9356.ind === p9354)) {
      this.skins.push({
        ind: p9354,
        cnt: p9355 || 1
      });
    } else {
      const v7816 = this.skins.find(p9357 => p9357.ind === p9354);
      if (v7816) {
        v7816.cnt += p9355 || 1;
      }
    }
  }
  removeSkin(p9358, p9359) {
    p9358 = parseInt(p9358);
    if (this.skins.some(p9360 => p9360.ind === p9358)) {
      const v7817 = this.skins.findIndex(p9361 => p9361.ind === p9358);
      if (v7817 >= 0) {
        this.skins[v7817].cnt -= p9359 || 1;
        if (this.skins[v7817].cnt <= 0) {
          this.skins.splice(v7817, 1);
        }
      }
    }
  }
  getSkinCount(p9362) {
    const v7818 = this.skins.find(p9363 => p9363.ind === p9362);
    if (v7818) {
      return v7818.cnt;
    } else {
      return 0;
    }
  }
  hasSkin(p9364) {
    return this.skins.some(p9365 => p9365.ind === p9364 && p9365.cnt > 0);
  }
  getData() {
    return [this.id, this.kills, this.wins, this.games, this.deaths, this.funds, this.score, this.clan, this.timePlayed, this.featured, this.skins, this.lastReward, this.isDev, this.following, this.followers, this.stats, this.hack, this.partnerName, this.partnerApp, this.regionInd, this.role, this.premiumT, !!this.twoFA, this.alias, this.createDate, this.twitch, this.isCreationMod, this.clanDeaths, this.clanKills, this.jobRating, this.jobRatingPos, this.reqDel, this.clanRole, this.clanTime, this.externalToken, this.twitchId, this.twitchAT, this.twitchRT, this.trades, this.refCode, this.email, this.isAdmin, this.invVal, this.junk, this.activeChallenges, this.badges, this.metamask, this.BP ? this.BP.bpp : 0, this.isSkinMaker];
  }
}
module.exports = C244;